export default "__VITE_ASSET__Bqe1UOzU__"